import { TEventFormData } from 'src/@types';
import { IEvent } from 'src/models';
import { TPageParams } from 'src/models/extensions/withPagination';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/event';

/**
 * 목록 조회
 */
export const getEvent = async (pageParams: TPageParams) => {
  try {
    const url = SUB_URL + objectToQueryString(pageParams);
    const response = await instance.get<TApiResponseData<IEvent[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (eventSid: number) => {
  try {
    const url = `${SUB_URL}/${eventSid}`;
    const response = await instance.get<TApiResponseData<IEvent>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 등록
 */
export const post = async (data: TEventFormData) => {
  try {
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<IEvent>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 수정
 */
export const put = async (eventSid: number, data: TEventFormData) => {
  try {
    const url = `${SUB_URL}/${eventSid}`;

    const response = await instance.put<TApiResponseData<IEvent>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 삭제
 */
export const remove = async (eventSid: number) => {
  try {
    const url = `${SUB_URL}/${eventSid}`;
    const response = await instance.delete<TApiResponseData<IEvent>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
